import React from "react";
import SearchInputsCemeteryConfig from "../../../../config/webgeo/SearchInputsCemeteryConfig";

import { Input } from "../../../global";

interface SearchInputs {
    input: string;
}

export const SearchInputsCemetery: React.FC<SearchInputs> = ({ input }) => {
    const inputConfig = SearchInputsCemeteryConfig[input];

    if (!inputConfig) return null;

    return (
        <div className="flex flex-col" key={input}>
            <Input
                name={input}
                label={inputConfig.label}
                icon={inputConfig.icon}
            />
        </div>
    );
};
